<div class="dialog-simple-confirmation" [ngClass]="{ show: _isVisible }">
  <svg
    class="confirmation-icon"
    [ngClass]="{ show: _isVisible }"
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    role="img"
    aria-labelledby="confirmation-icon-title"
  >
    <title id="confirmation-icon-title">{{ 'accessibilite.confirmation-icone' | translate }}</title>
    <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
      <path
        class="checkmark"
        stroke="#00874E"
        d="M13.5 18l6.588 9.222c.55.77 1.425 1.24 2.37 1.276.945.035 1.853-.37 2.458-1.096L46.5 1.498"
      />
      <path
        class="circle"
        stroke="#363636"
        d="M33.566 7.648c-8.842-5.472-20.359-3.64-27.065 4.307-6.707 7.946-6.58 19.607.3 27.404 6.88 7.798 18.433 9.377 27.153 3.713 8.72-5.665 11.974-16.863 7.646-26.318"
      />
    </g>
  </svg>

  <h1 *ngIf="title" class="title delayed-show first">
    {{ title | translate }}
  </h1>

  <p *ngIf="paragraph" class="delayed-show first dsd-ta-center">{{ paragraph | translate }}</p>

  <div class="buttons delayed-show second">
    <button
      mat-button
      id="btn-fermer-secondaire"
      (click)="close.emit()"
      class="green full-width-xs"
      cdkFocusInitial
      #actionButton
    >
      {{ (buttonLabel ? buttonLabel : 'btn.fermer') | translate }}
    </button>
  </div>
</div>
